"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleDriver = void 0;
exports.isIndividualSimpleDriver = isIndividualSimpleDriver;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Position_1 = require("../models/Position");
const SimpleUser_1 = require("../models/SimpleUser");
let SimpleDriver = class SimpleDriver extends SimpleUser_1.SimpleUser {
    get status() {
        if ((0, utils_1.isNotUndefinedOrNull)(this.declinedAt)) {
            return legacy_enums_1.DriverStatus.Declined;
        }
        if ((0, utils_1.isNotUndefinedOrNull)(this.activeAt)) {
            return legacy_enums_1.DriverStatus.Active;
        }
        return legacy_enums_1.DriverStatus.Hired;
    }
    score = 0;
    hiredAt;
    activeAt;
    declinedAt;
    lastLoginAt;
    town = "";
    managementNote = "";
    willingToSleepoverCount = 1;
    position;
    companyUserId;
    isCompany = false;
    amountOfDrivers = 0;
    isCompanyDriver = false;
    isSuitableForLuxury = false;
    isSuitableForPool = false;
    canSpeakEnglish = false;
    willingToDoLite = true;
    isTCPDriver = false;
    willingToRentVehicleTypes = [];
};
exports.SimpleDriver = SimpleDriver;
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Exclude)({ toClassOnly: true }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], SimpleDriver.prototype, "status", null);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Max)(5),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleDriver.prototype, "score", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], SimpleDriver.prototype, "hiredAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], SimpleDriver.prototype, "activeAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], SimpleDriver.prototype, "declinedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], SimpleDriver.prototype, "lastLoginAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleDriver.prototype, "town", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleDriver.prototype, "managementNote", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleDriver.prototype, "willingToSleepoverCount", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Position_1.Position),
    __metadata("design:type", Position_1.Position)
], SimpleDriver.prototype, "position", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SimpleDriver.prototype, "companyUserId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SimpleDriver.prototype, "isCompany", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleDriver.prototype, "amountOfDrivers", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SimpleDriver.prototype, "isCompanyDriver", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SimpleDriver.prototype, "isSuitableForLuxury", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SimpleDriver.prototype, "isSuitableForPool", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], SimpleDriver.prototype, "canSpeakEnglish", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], SimpleDriver.prototype, "willingToDoLite", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], SimpleDriver.prototype, "isTCPDriver", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Array)
], SimpleDriver.prototype, "willingToRentVehicleTypes", void 0);
exports.SimpleDriver = SimpleDriver = __decorate([
    (0, class_transformer_1.Exclude)()
], SimpleDriver);
function isIndividualSimpleDriver(driver) {
    return !driver.isCompany;
}
//# sourceMappingURL=SimpleDriver.js.map